<ion-searchbar
  class="search dashboard-search"
  data-cy="dashboard-search"
  id="customer-searchbar"
  mode="md"
  [placeholder]="'i18n.header.search' | translate"
  [(ngModel)]="searchText"
  (ionBlur)="handleInputBlur($event)"
  (ionFocus)="handleInputFocus($event)"
  (ionInput)="search($event)"
  (keydown.enter)="selectFilteredItems()"
  (keydown)="handleArrowKeys($event)"
></ion-searchbar>
<div *ngIf="isTypeAheadVisible && searchGroups.length > 0" class="type-ahead">
  <section *ngFor="let group of searchGroups">
    <h2 [attr.data-cy]="'group-' + group.name">{{ group.name }}</h2>
    <ul>
      <li
        *ngFor="let item of group.items; let i = index"
        [attr.data-cy]="'group-item-' + item.value"
        [class]="{
          active: item.value === activeItem?.value,
        }"
        innerHTML="{{
          item.needsTitleCase ? (item.name | titlecase) : item.name
        }}"
        (click)="selectItem(item, group)"
      ></li>
    </ul>
  </section>
</div>
